import Sign from "../components/user/Sign";

const SignUp = (props) => {
  return <Sign setIsLogIn={props.setIsLogIn} />;
};

export default SignUp;
